import reduxApi from 'redux-api';
import capitalize from 'lodash/capitalize';
import { tokenOptions, adapterJquery, handleError, parseAuth, baseApiUrl } from './ApiHelpers';
import ApiError from './ApiError';
import { logout } from '../utils/helpers/store';
import PublisherApi from './PublisherApi';
import AdvertiserApi from './AdvertiserApi';
import SspApi from './SspApi';

export default reduxApi({
  /////////////////////////  Login Endpoint ///////////////////////////////////
  auth: {
    url: `${baseApiUrl}/v1/users/login`,
    helpers: {
      post(data) {
        return [
          {},
          {
            data,
            method: 'POST',
            cb: (resolve, reject, jqXHR) => {
              const auth = jqXHR.getResponseHeader('Authorization');
              const { token, payload, expired, error } = parseAuth(auth);
              if (error) reject(error);
              return resolve({ token, payload, expired, isAuthenticated: true });
            },
          },
        ];
      },
    },
    postfetch: [
      ({ dispatch, actions }) => {
        dispatch(actions.user());
      },
    ],
  },
  forgotPassword: {
    url: `${baseApiUrl}/v1/users/password`,
    virtual: true,
    helpers: {
      post(data) {
        return [
          {},
          {
            data,
            method: 'POST',
          },
        ];
      },
    },
  },
  resetPassword: {
    url: `${baseApiUrl}/v1/users/password`,
    virtual: true,
    helpers: {
      put(data) {
        return [
          {},
          {
            data,
            method: 'PUT',
          },
        ];
      },
    },
  },
  ////////////////////////  Logout Endpoint ///////////////////////////////////
  logout: {
    url: `${baseApiUrl}/v1/users/logout`,
    options: {
      method: 'DELETE',
    },
    virtual: true,
    postfetch: [
      ({ dispatch }) => {
        logout(dispatch);
      },
    ],
    prefetch: [
      ({ getState }, cb) => {
        const {
          auth: {
            data: { isAuthenticated },
          },
        } = getState();
        const error = new ApiError('Authentication failed', 'Unauthorized', 401).error;
        return isAuthenticated ? cb() : handleError(error) && cb(error);
      },
    ],
  }, /////////////////////////  User Endpoint ///////////////////////////////////
  user: {
    url: `${baseApiUrl}/v1/users/me`,
    options: {
      method: 'GET',
    },
    transformer: data => {
      const d = data ? { ...data.data } : {};
      if (d.roles) d.roles.forEach(r => (d[`is${capitalize(r)}`] = true));
      return d;
    },
    postfetch: [
      ({ dispatch, getState }) => {
        const {
          user: {
            data: { isPublisher, isAdvertiser, isSsp },
          },
        } = getState();
        if (isPublisher) {
          dispatch(PublisherApi.actions.websites());
        } else if (isAdvertiser) {
          dispatch(AdvertiserApi.actions.accounts());
          dispatch(AdvertiserApi.actions.customers());
        } else if (isSsp) {
          dispatch(SspApi.actions.websites());
          dispatch(SspApi.actions.feedSources());
        }
      },
    ],
  },
})
  .use('options', tokenOptions)
  .use('fetch', adapterJquery);
